const LOADING = "loading"
const ERROR = "error"
const WAITING = "waiting"

// GAME STATUSES
const CHOICE = "choice"
const DEALING = "dealing"
const GAMEPLAY = "gameplay"
const GAME = "game"

/* Niu Niu asks the player nothing once the cards are out. He puts his stakes down, the
   dealer deals twenty-one cards, and the round pays itself — there are no streets to play
   through and no decision to make, so the only window with a clock on it is the betting. */

export { LOADING, ERROR, WAITING, CHOICE, DEALING, GAMEPLAY, GAME }
